export default __webpack_public_path__ + "static/media/mandate-icon.1e74fa5c.svg";